export default "__VITE_ASSET__TTJ1sSkQ__"